import { render, staticRenderFns } from "./billGroupDetail.vue?vue&type=template&id=e6cb1eb6&"
import script from "./billGroupDetail.vue?vue&type=script&lang=js&"
export * from "./billGroupDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e6cb1eb6')) {
      api.createRecord('e6cb1eb6', component.options)
    } else {
      api.reload('e6cb1eb6', component.options)
    }
    module.hot.accept("./billGroupDetail.vue?vue&type=template&id=e6cb1eb6&", function () {
      api.rerender('e6cb1eb6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Clearing/components/BillingNative/billGroupDetail.vue"
export default component.exports